import iposApi from './iposApi';

export default {
  setupInterceptors: (store, history) => {

    iposApi.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      // if (error && (error.message === 'Network Error' || error.code === 'ECONNABORTED' )) {
      //   alert('קיימת בעיית תקשורת! נא לנסות יותר מאוחר');
      //   history.push('/auth');
      // }
      return Promise.reject(error);
    });
  }
};
